import { createFoundationUseCases } from "../useCases/foundation";
import { createLocalDataAccess } from "../../data/local";
import { createFirestoreRemoteDataAccess } from "../../data/remote/firestore";
import { createSyncEngine } from "../../data/sync";

export const createFoundationRuntime = ({
  localDataAccess,
  remoteDataAccess,
} = {}) => {
  const resolvedLocalDataAccess = localDataAccess || createLocalDataAccess();
  const resolvedRemoteDataAccess =
    remoteDataAccess || createFirestoreRemoteDataAccess();

  return {
    localDataAccess: resolvedLocalDataAccess,
    remoteDataAccess: resolvedRemoteDataAccess,
    syncEngine: createSyncEngine({
      localDataAccess: resolvedLocalDataAccess,
      remoteDataAccess: resolvedRemoteDataAccess,
    }),
    useCases: createFoundationUseCases({
      localDataAccess: resolvedLocalDataAccess,
    }),
  };
};
